import type { VergeOption } from "../types";

const getVergeTilesCoverWidth = (
  vergeOption: VergeOption,
  battenSpacing: number
): number => {
  const hasType7VergeTiles =
    vergeOption.rightVergeTileType7 && vergeOption.leftVergeTileType7;
  const hasType9VergeTiles =
    vergeOption.rightVergeTileType9 && vergeOption.leftVergeTileType9;

  if (
    battenSpacing >= 36 &&
    battenSpacing <= 37 &&
    (hasType7VergeTiles || hasType9VergeTiles)
  ) {
    if (hasType7VergeTiles) {
      return (
        vergeOption.rightVergeTileType7!.coverWidth +
        vergeOption.leftVergeTileType7!.coverWidth
      );
    }

    return (
      vergeOption.rightVergeTileType9!.coverWidth +
      vergeOption.leftVergeTileType9!.coverWidth
    );
  }

  if (battenSpacing >= 34 && battenSpacing < 36 && hasType9VergeTiles) {
    return (
      vergeOption.rightVergeTileType9!.coverWidth +
      vergeOption.leftVergeTileType9!.coverWidth
    );
  }

  return vergeOption.right.coverWidth + vergeOption.left.coverWidth;
};

export default getVergeTilesCoverWidth;
